import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const names = {
    ORANJE: "Oranje",
    ROOD: "Rood",
    WIT: "Wit",
    BLAUW: "Blauw",
    ROZE: "Roze",
    GROEN: "Groen",
    GEEL: "Geel",
    GRIJS: "Grijs",
    BRUIN: "Bruin",
    BEIGE: "Beige",
    CREME: "Creme",
    PAARS: "Paars",
    ZWART: "Zwart",
    GOUD: "Goud",
    ZILVER: "Zilver",
    DIVERS: "Divers"
};

export const KleurFilter = ({ condensed }) => {
    const filter = useFilter("kleur");
    const count = useCount("kleur");
    const [value, , onChange] = useField("kleuren");

    const options =
        filter.map((option) => ({
            id: option,
            displayName: names[option],
            aantal: count[option]
        })) || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-kleuren"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 5}
                datalayerKey="kleur"
                maxSize={condensed ? 5 : 0}
            />
        </Grid>
    );
};
